import { createFileRoute } from "@tanstack/react-router";
import { ProductDetailPage } from "../../../components/products/ProductDetailPage";

export const Route = createFileRoute("/workspace/products/$productId/")({
  component: ProductDetailRoute,
});

function ProductDetailRoute() {
  const { productId } = Route.useParams();
  return <ProductDetailPage productId={productId} />;
}
